import React from 'react';
import {useSelector} from "react-redux";
import {bbFindEntityWithinPortfolioOrSelf, bbFindUsersOnboardingProgress} from "../../../util/bbHelpers";
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import {styled} from "@material-ui/core";
import {HashLink as Link} from "react-router-hash-link";


const OnboardingProgressMenuItem = ({props}) => {

    const {authUser, } = useSelector(({auth})=> auth);
    const {portfolios, entityInView, loadingPortfolios, selfEntityId} = useSelector(({breachrisk}) => breachrisk);
    const {customers, customerInView, loadingCustomers} = useSelector(({customer})=> customer);

    const myEntity = bbFindEntityWithinPortfolioOrSelf(selfEntityId, portfolios, customerInView);

    const customer = customers && customerInView && customers[customerInView] ? customers[customerInView] : null;

    // console.log("onboarding items", userOnboardingProgress, completedOnboardingItems, totalOnboardingItems, "myEntity", myEntity)

    const userOnboardingProgress = bbFindUsersOnboardingProgress(myEntity, authUser);

    const completedOnboardingItems = userOnboardingProgress && userOnboardingProgress.filter(item => item.value === true).length;
    const totalOnboardingItems = userOnboardingProgress && userOnboardingProgress.length;
    const percentOnboardingComplete = userOnboardingProgress ? (completedOnboardingItems/totalOnboardingItems) * 100 : 0;

    return(
        percentOnboardingComplete !== 100
            ?
            <div id={"progressBarMenuItem"} className={"my-0 py-0 text-center"} title={"Ensure you're getting the most out of your service by completing your company's account. Click to see more on your settings page."}>
            <Link smooth to={`/board/settings/account`}>

                <LinearProgress
                    variant="determinate"
                    value={percentOnboardingComplete}
                    // sx={{height: 10}}
                    sx={{
                        height: 12,
                        borderRadius: 5,
                        [`&.${linearProgressClasses.colorPrimary}`]: {
                            backgroundColor: '#757575',
                        },
                        // [`&.${linearProgressClasses.colorPrimary}`]:{
                        //     backgroundColor: #757575,},
                        [`& .${linearProgressClasses.bar}`]: {
                            borderRadius: 0,
                            backgroundColor: '#0460D9',
                        },
                        display: "flex",
                    }}
                />
                <div className={"d-flex text-white-50 text-center"} style={{position: "absolute", top: 0, left: "25%"}}>
                   <small>
                       GETTING STARTED
                   </small>
               </div>
            </Link>
        </div>
            : <span id={"progressBarMenuItem"}/>
    )
}

export default OnboardingProgressMenuItem